<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>


export default {
  name: 'app',
//   mounted() {
// 	  this.$router.push({path:"index"})
//   }
}
</script>


<style>
@import '../src/fonts/font.css';
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
}
.logo {
	border: 0;
	box-shadow: 0;
	width:16.67vw;
	transition: all 0.5s;
	-webkit-transition: all 0.5s;
}
.logo:hover {
	transform: scale(0.9);
	-webkit-transform: scale(0.9);
}
.logombz {
	border: 0;
	box-shadow: 0;
	width:10vw;
	transition: all 0.5s;
	-webkit-transition: all 0.5s;
}
.logombz:hover {
	transform: scale(0.9);
	-webkit-transform: scale(0.9);
}
.logonyu {
	border: 0;
	box-shadow: 0;
	width:10vw;
	transition: all 0.5s;
	-webkit-transition: all 0.5s;
}
.logonyu:hover {
	transform: scale(0.9);
	-webkit-transform: scale(0.9);
}
.index-gallery {
	z-index: 1;
}
.index-topbar {
  min-width: 1000px;
	z-index: 2;
}
</style>
